// extracted by mini-css-extract-plugin
export var attachment = "_m3-a";
export var emailContainer = "_m3-4";
export var emailContentPaddedContainer = "_m3-b";
export var emailHeader = "_m3-6";
export var emailIframe = "_m3-3";
export var emailInfoIcon = "_m3-9";
export var emailShortenedSummary = "_m3-e";
export var infoDropdown = "_m3-0";
export var infoRowBoundedContent = "_m3-d";
export var internal = "_m3-5";
export var merchant = "_m3-8";
export var messageInputContainer = "_m3-h";
export var normal = "_m3-7";
export var replyCard = "_m3-f";
export var subtleButton = "_m3-1";
export var subtleButtonIconContainer = "_m3-2";
export var toggleViewRepliesButton = "_m3-c";
export var wrappingText = "_m3-g";